<template>
  <div class="pa-4" style="position: relative; height: 100%;">

    <v-row class="justify-center">
      
      <v-col
        cols="4"
      >
        <div class="subtitle-1">Owner</div>
        <user-search-field 
          :user.sync="owner" 
          clearable
          :agent-id="(household.user.agent_id || null)"
          label="Choose Owner"
        />
      </v-col>
      <v-col
        cols="4"
      >
        <div class="subtitle-1">Spouse</div>
        <user-search-field 
          :user.sync="spouse" 
          clearable
          :agent-id="(household.user.agent_id || null)"
          label="Choose Spouse"
        />
      </v-col>

      <v-col
        cols="8"
      >
        <v-row class="justify-center">
          <v-col cols="4">
            <div class="subtitle-1">Plans Prepared By</div>
            <v-text-field
              v-if="household.user"
              v-model="newPreparedBy"
              dense
              hide-details
              outlined
              :disabled="saving"
              :placeholder="household.user.agent.full_name"
              clearable
            />
          </v-col>
          <v-col cols="4">
            <div class="subtitle-1">Plans Prepared By Title</div>
            <v-text-field
              v-if="household.user"
              v-model="newPreparedByTitle"
              dense
              hide-details
              outlined
              :disabled="saving"
              :placeholder="household.user.agent.title"
              clearable
            />
          </v-col>
          <v-col cols="4">
            <div class="subtitle-1">Plans Prepared By Emails</div>
            <v-text-field
              v-if="household.user"
              v-model="newPreparedByEmail"
              dense
              hide-details
              outlined
              :disabled="saving"
              :placeholder="household.user.agent.email"
              clearable
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="11" class="py-4">
        <v-divider />
      </v-col>

      <v-col
        cols="8"
      > 
        <v-row class="text-left align-center">
          
          <v-col cols="12" class="py-0">
            <div class="subtitle-1">Desired outcomes</div>
            <v-row 
              v-for="(desout,desind) in desiredOutcomes"
              :key="'di-' + desind"
            >
              <v-col cols="12" class="py-2">
                <v-text-field
                  v-model="desiredOutcomes[desind]"
                  outlined
                  dense
                  hide-details
                  placeholder="Enter Outcome Here..."
                  :append-outer-icon="(desiredOutcomes.length > 1 ? 'mdi-close' : null)"
                  @click:append-outer="removeDesiredOutcome(desind)"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="text-center mt-4">
            <v-btn small color="primary" @click="addDesiredOutcomes" outlined :disabled="desiredOutcomes.length >= 5"><v-icon small>mdi-plus</v-icon> Add Desired Outcome</v-btn>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="11" class="py-4">
        <v-divider />
      </v-col>

      <v-col
        cols="8"
      >
        <v-row class="justify-center">
          <v-col cols="12" class="py-0">
            <div class="subtitle-1 text-left">Main Incomes</div>
            <v-row 
              v-for="(income,incomeIndex) in mainIncomes"
              :key="'mainincome-' + incomeIndex"
              class="justify-center"
            >
              <v-col cols="6" class="py-1">
                <v-text-field
                  v-model="income.name"
                  outlined
                  dense
                  hide-details
                  label="Name"
                />
              </v-col>
              <v-col cols="6" class="py-1">
                <v-text-field
                  v-model="income.amount"
                  outlined
                  dense
                  hide-details
                  label="Monthly Amount ($)"
                  :append-outer-icon="(mainIncomes.length > 1 ? 'mdi-close' : null)"
                  @click:append-outer="removeMainIncome(incomeIndex)"
                />
              </v-col>
              <!--<v-col cols="4" class="py-1">
                <v-text-field
                  v-model="income.increase"
                  outlined
                  dense
                  hide-details
                  label="Annual Increase ($)"
                  :append-outer-icon="(mainIncomes.length > 1 ? 'mdi-close' : null)"
                  @click:append-outer="removeMainIncome(incomeIndex)"
                />
              </v-col>-->
            </v-row>
          </v-col>

          <v-col cols="12" class="text-center mt-4">
            <v-btn small color="primary" @click="addMainIncome" outlined><v-icon small>mdi-plus</v-icon> Add Main Income</v-btn>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="11" class="py-4">
        <v-divider />
      </v-col>

      <v-col
        cols="8"
      >
        <v-row class="justify-center">
          <v-col cols="12" class="py-0">
            <div class="subtitle-1 text-left">Passive Incomes</div>
            <v-row 
              v-for="(income,incomeIndex) in incomes"
              :key="'income-' + incomeIndex"
            >
              <v-col cols="6" class="py-1">
                <v-text-field
                  v-model="income.name"
                  outlined
                  dense
                  hide-details
                  label="Name"
                />
              </v-col>
              <v-col cols="6" class="py-1">
                <v-text-field
                  v-model="income.amount"
                  outlined
                  dense
                  hide-details
                  label="Monthly Amount ($)"
                  :append-outer-icon="(incomes.length > 1 ? 'mdi-close' : null)"
                  @click:append-outer="removeIncome(incomeIndex)"
                />
              </v-col>
              <!--<v-col cols="3" class="py-1">
                <v-text-field
                  v-model="income.increase"
                  outlined
                  dense
                  hide-details
                  label="Annual Increase ($)"
                />
              </v-col>
              <v-col cols="3" class="py-1">
                <v-text-field
                  v-model="income.until"
                  outlined
                  dense
                  hide-details
                  label="Continues Until"
                  :append-outer-icon="(incomes.length > 1 ? 'mdi-close' : null)"
                  @click:append-outer="removeIncome(incomeIndex)"
                />
              </v-col>-->
            </v-row>
          </v-col>

          <v-col cols="12" class="text-center mt-4">
            <v-btn small color="primary" @click="addIncome" outlined><v-icon small>mdi-plus</v-icon> Add Passive Income</v-btn>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="11" class="py-4">
        <v-divider />
      </v-col>
      
      <v-col
        cols="8"
      >  
        <v-row>
          <v-col cols="12" class="py-0"><div class="subtitle-1 text-left">Current life insurance policies</div></v-col>
          <v-col
            cols="12"
            v-for="(iAccount, iIndex) in insurances"
            :key="'insurance-debt-' + iIndex"
            class="py-2"
          >
            <v-row class="justify-start">
              <v-col cols="2" class="py-0">
                <v-select
                  v-model="iAccount.owner"
                  :items="ownerSelections"
                  hide-details
                  outlined
                  dense
                  placeholder="Choose..."
                  label="Owner"
                  clearable
                />
              </v-col>
              <v-col class="py-0" style="width: 240px; max-width: 240px; min-width: 240px;">
                <v-select
                  v-model="iAccount.type"
                  :items="[{text: 'Term Insurance', value: 'term'},{text: 'Cash Insurance', value: 'cash'}]"
                  hide-details
                  outlined
                  dense
                  label="What Type"
                  placeholder="Choose"
                  clearable
                />
              </v-col>
              <v-col v-if="iAccount.type && iAccount.owner" class="py-0">
                <v-text-field
                  v-model="iAccount.company"
                  hide-details
                  outlined
                  dense
                  clearable
                  label="Company"
                />
              </v-col>
              <v-col v-if="iAccount.type && iAccount.owner" class="py-0">
                <v-text-field
                  v-model="iAccount.death_benefit"
                  hide-details
                  outlined
                  dense
                  clearable
                  label="Death Benefit"
                />
              </v-col>
              <v-col  v-if="iAccount.type && iAccount.owner" class="py-0">
                <v-text-field
                  v-model="iAccount.monthly_premium"
                  hide-details
                  outlined
                  dense
                  clearable
                  label="Monthly Premium"
                />
              </v-col>
              
              <v-col v-if="iAccount.type == 'term' && iAccount.owner" class="py-0">
                <v-text-field
                  v-model="iAccount.term_left"
                  hide-details
                  outlined
                  dense
                  clearable
                  label="Term Left"
                />
              </v-col>
              <v-col v-if="iAccount.type == 'cash' && iAccount.owner" class="py-0">
                <v-text-field
                  v-model="iAccount.cash_value"
                  hide-details
                  outlined
                  dense
                  clearable
                  label="Cash Value"
                />
              </v-col>
              <v-spacer v-if="insurances.length > 1 && (!iAccount.owner || !iAccount.type)" />
              <v-col class="py-0 flex-grow-0 flex-shrink-1" v-if="insurances.length > 1">
                <v-btn text style="min-width: 0px;" class="px-3" @click="removeInsurance(iIndex)"><v-icon>mdi-close</v-icon></v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="text-center mt-4">
            <v-btn small color="primary" outlined @click="addInsurance"><v-icon small>mdi-plus</v-icon> Add Insurance</v-btn>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="11" class="py-4">
        <v-divider />
      </v-col>

      <v-col
        cols="8"
      >
        <v-row>
          <v-col cols="12" class="py-0"><div class="subtitle-1 text-left">Liquid assets</div></v-col>
          <v-col
            cols="12"
            v-for="(sAccount, sIndex) in savings"
            :key="'savings-account-' + sIndex"
            class="py-3"
          >
            <v-row class="align-center justify-start">
              <v-col cols="2" class="py-0">
                <v-select
                  v-model="sAccount.owner"
                  :items="ownerSelections"
                  hide-details
                  outlined
                  dense
                  placeholder="Choose..."
                  label="Owner"
                  clearable
                />
              </v-col>
              <v-col class="py-0" v-if="sAccount.owner" style="width: 240px; max-width: 240px; min-width: 240px;">
                <v-select
                  v-model="sAccount.type"
                  :items="savingsSelections"
                  hide-details
                  outlined
                  dense
                  placeholder="Choose..."
                  label="Type"
                  clearable
                />
              </v-col>
              <v-col class="py-0" v-if="sAccount.owner && sAccount.type" style="width: 160px; max-width: 160px; min-width: 160px;">
                <v-text-field
                  v-model="sAccount.current_value"
                  outlined
                  dense
                  hide-details
                  label="Current Value"
                />
              </v-col>
              <v-col cols="2" class="py-0" v-if="sAccount.owner && sAccount.type && sAccount.type == 'savings'">
                <v-text-field
                  v-model="sAccount.monthly_contribution"
                  outlined
                  dense
                  hide-details
                  label="Monthly Contribution"
                />
              </v-col>
              <v-spacer v-if="savings.length > 1" />
              <v-col class="py-0 flex-grow-0 flex-shrink-1" v-if="savings.length > 1">
                <v-btn text style="min-width: 0px;" class="px-3" @click="removeSavings(sIndex)"><v-icon>mdi-close</v-icon></v-btn>
              </v-col>
            </v-row>
          </v-col>
          
          <v-col cols="12" class="text-center mt-4">
            <v-btn small color="primary" @click="addSavings" outlined><v-icon small>mdi-plus</v-icon> Add Savings Account</v-btn>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="11" class="py-4">
        <v-divider />
      </v-col>

      <v-col
        cols="8"
      >
        <v-row>
          <v-col cols="12" class="py-0"><div class="subtitle-1 text-left">Retirement accounts</div></v-col>
          <v-col
            cols="12"
            v-for="(rAccount, rIndex) in retirements"
            :key="'retirement-debt-' + rIndex"
            class="py-3"
          >
            <v-row class="align-center justify-start">
              <v-col cols="2" class="py-0">
                <v-select
                  v-model="rAccount.owner"
                  :items="ownerSelections"
                  hide-details
                  outlined
                  dense
                  placeholder="Choose..."
                  label="Owner"
                  clearable
                />
              </v-col>
              <v-col class="py-0" v-if="rAccount.owner" style="width: 240px; max-width: 240px; min-width: 240px;">
                <v-select
                  v-model="rAccount.type"
                  :items="retirementSelections"
                  hide-details
                  outlined
                  dense
                  placeholder="Choose..."
                  label="Type"
                  clearable
                />
              </v-col>
              <v-col class="py-0" v-if="rAccount.owner && rAccount.type" style="width: 160px; max-width: 160px; min-width: 160px;">
                <v-text-field
                  v-model="rAccount.current_value"
                  outlined
                  dense
                  hide-details
                  label="Current Value"
                />
              </v-col>
              <v-col cols="2" class="py-0" v-if="rAccount.owner && rAccount.type && rAccount.type != 'old401k'">
                <v-text-field
                  v-model="rAccount.monthly_contribution"
                  outlined
                  dense
                  hide-details
                  label="Monthly Contribution"
                />
              </v-col>
              <v-col cols="2" class="py-0" v-if="rAccount.owner && rAccount.type == '401k'">
                <v-text-field
                  outlined
                  v-model="rAccount.employer_matchback_amount"
                  label="Employer Contribution"
                  dense
                  hide-details
                />
              </v-col>
              <v-spacer v-if="retirements.length > 1 && (rAccount.type != '401k' || !rAccount.employer_matchback)" />
              <v-col class="py-0 flex-grow-0 flex-shrink-1" v-if="retirements.length > 1">
                <v-btn text style="min-width: 0px;" class="px-3" @click="removeRetirement(rIndex)"><v-icon>mdi-close</v-icon></v-btn>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="text-center mt-4">
            <v-btn small color="primary" @click="addRetirement" outlined><v-icon small>mdi-plus</v-icon> Add Retirement Account</v-btn>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="11" class="py-4">
        <v-divider />
      </v-col>

      <v-col
        cols="8"
      >
        <v-row class="py-0"><v-col><div class="subtitle-1 text-left">Question & Answers</div></v-col></v-row>
        <v-row class="flex-nowrap">
          <v-col>
            <ol>
              <li value="1">Are you anticipating any major lifestyle changes?<br>(ie., marriage, divorce, retirement, moving etc.)
              </li>
            </ol>
          </v-col>
          <v-col class="text-no-wrap flex-shrink-1 flex-grow-0" style="min-width: 300px;">
            <v-radio-group row v-model="lifestyleChanges" dense hide-details class="mt-0">
              <v-radio
                label="Yes"
                value="yes"
              ></v-radio>
              <v-radio
                label="No"
                value="no"
              ></v-radio>
              <v-radio
                label="Uncertain"
                value="uncertain"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row v-if="lifestyleChanges == 'yes'">
          <v-col cols="12" class="pt-0 pl-9">
            <v-textarea
              v-model="lifestyleChangeReason"
              outlined
              label="What changes are you expecting?"
              hide-details
            />
          </v-col>
        </v-row>
        <v-row class="flex-nowrap align-center">
          <v-col class="text-no-wrap">
            <ol>
              <li value="2">Are you happy with your current cash flow?
              </li>
            </ol>
          </v-col>
          <v-col class="text-no-wrap flex-shrink-1 flex-grow-0" style="min-width: 300px;">
            <v-radio-group row v-model="happyCurrentCashflow" dense hide-details class="mt-0" >
              <v-radio
                label="Yes"
                value="yes"
              ></v-radio>
              <v-radio
                label="No"
                value="no"
              ></v-radio>
              <v-radio
                label="Uncertain"
                value="uncertain"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row v-if="happyCurrentCashflow == 'no'">
          <v-col cols="12" class="pt-0 pl-9">
            <v-textarea
              v-model="whyNotHappy"
              outlined
              label="Why not?"
              hide-details
            />
          </v-col>
        </v-row>
        <v-row class="flex-nowrap align-center">
          <v-col class="text-no-wrap">
            <ol>
              <li value="3">
                Do you anticipate any significant changes in your cash flow?
              </li>
            </ol>
          </v-col>
          <v-col class="text-no-wrap flex-shrink-1 flex-grow-0" style="min-width: 300px;">
            <v-radio-group row v-model="anticipateCashflowChanges" dense hide-details class="mt-0">
              <v-radio
                label="Yes"
                value="yes"
              ></v-radio>
              <v-radio
                label="No"
                value="no"
              ></v-radio>
              <v-radio
                label="Uncertain"
                value="uncertain"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row v-if="anticipateCashflowChanges == 'yes'">
          <v-col cols="12" class="pt-0 pl-9">
            <v-textarea
              v-model="cashflowChanges"
              outlined
              label="What changes are you expecting?"
              hide-details
            />
          </v-col>
        </v-row>
        <v-row class="flex-nowrap align-center">
          <v-col class="text-no-wrap">
            <ol>
              <li value="4">
                Do you anticipate any major expenditures in the near future?
              </li>
            </ol>
          </v-col>
          <v-col class="text-no-wrap flex-shrink-1 flex-grow-0" style="min-width: 300px;">
            <v-radio-group row v-model="anticipateMajorExpenditures" dense hide-details class="mt-0">
              <v-radio
                label="Yes"
                value="yes"
              ></v-radio>
              <v-radio
                label="No"
                value="no"
              ></v-radio>
              <v-radio
                label="Uncertain"
                value="uncertain"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row v-if="anticipateMajorExpenditures == 'yes'">
          <v-col cols="12" class="pt-0 pl-9">
            <v-textarea
              v-model="majorExpenditure"
              outlined
              label="What expenditures?"
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col
        cols="12"
        class="text-center"
      >
        <v-btn @click="saveSettings" :loading="saving" color="primary">Save</v-btn>
      </v-col>

    </v-row>
  </div>
</template>

<script>
import UserSearchField from '@/components/UserSearchField'

export default {
  name: 'HouseholdSettings',
  props: {
    household: {
      type: Object,
      required: true
    }
  },
  components: {
    UserSearchField
  },
  data () {
    return {
      step: 1,
      saving: false,
      owner: null,
      spouse: null,
      mainIncomes: [],
      incomes: [],
      insurances: [],
      retirements: [],
      savings: [],
      desiredOutcomes: [],

      userHasSavings: false,
      userSavingsCumulative: null,
      userSavingsContribution: null,
      userHasCds: false,
      userCdsCumulative: null,

      spouseHasSavings: false,
      spouseSavingsCumulative: null,
      spouseSavingsContribution: null,
      spouseHasCds: false,
      spouseCdsCumulative: null,

      lifestyleChanges: null,
      lifestyleChangeReason: null,
      happyCurrentCashflow: null,
      whyNotHappy: null,
      anticipateCashflowChanges: null,
      cashflowChanges: null,
      anticipateMajorExpenditures: null,
      majorExpenditure: null,

      newPreparedBy: null,
      newPreparedByTitle: null,
      newPreparedByEmail: null,

      expansions: 'user,spouse,user.agent,plans',
    }
  },
  mounted() {
    this.reset()
  },
  watch: {
  },
  computed: {
    namePlural() {
      if(this.household.user.first_name[ this.household.user.first_name.length - 1 ] == 's') return this.household.user.first_name + '\''
      return this.household.user.first_name + '\'s'
    },
    ownerSelections() {
      let arr = []
      arr.push({text: this.household.user.full_name, value: 'user'});
      if(this.spouse) arr.push({text: this.spouse.full_name, value: 'spouse'});
      return arr
    },
    retirementSelections() {
      return [
        {
          text: 'Active 401(k)',
          value: '401k'
        },
        {
          text: 'Old 401(k)',
          value: 'old401k'
        },
        {
          text: 'IRA',
          value: 'ira'
        },
        {
          text: 'Roth IRA',
          value: 'roth'
        }
      ]
    },
    savingsSelections() {
      return [
        {
          text: 'Savings Account',
          value: 'savings'
        },
        {
          text: 'C.D.',
          value: 'cd'
        }
      ]
    }
  },
  methods: {
    reset() {
      let intake                              = (Array.isArray(this.household.intake) ? {} : this.household.intake)
      this.mainIncomes                        = intake.mainIncomes || []
      this.incomes                            = intake.incomes || []
      this.insurances                         = intake.insurances || []
      this.retirements                        = intake.retirements || []
      this.savings                            = intake.savings || []
      this.owner                              = this.household.user
      this.spouse                             = this.household.spouse ?? null
      this.lifestyleChanges                   = intake.lifestyleChanges ?? null
      this.lifestyleChangeReason              = intake.lifestyleChangeReason ?? null
      this.happyCurrentCashflow               = intake.happyCurrentCashflow ?? null
      this.whyNotHappy                        = intake.whyNotHappy ?? null
      this.anticipateCashflowChanges          = intake.anticipateCashflowChanges ?? null
      this.cashflowChanges                    = intake.cashflowChanges ?? null
      this.anticipateMajorExpenditures        = intake.anticipateMajorExpenditures ?? null
      this.majorExpenditure                   = intake.majorExpenditure ?? null
      this.desiredOutcomes                    = intake.desiredOutcomes || []

      this.newPreparedBy                      = this.household.prepared_by
      this.newPreparedByTitle                 = this.household.prepared_by_title
      this.newPreparedByEmail                 = this.household.prepared_by_email

      if(!this.mainIncomes.length) this.addMainIncome()
      if(!this.incomes.length) this.addIncome()
      if(!this.insurances.length) this.addInsurance()
      if(!this.retirements.length) this.addRetirement()
      if(!this.savings.length) this.addSavings()
      if(!this.desiredOutcomes.length) this.addDesiredOutcomes()
    },
    addMainIncome() {
      this.mainIncomes.push({
        name: null,
        amount: null,
        increase: null
      })
    },
    removeMainIncome(index) {
      this.mainIncomes.splice(index, 1)
    },
    addIncome() {
      this.incomes.push({
        name: null,
        amount: null,
        increase: null,
        until: null
      })
    },
    removeIncome(index) {
      this.incomes.splice(index, 1)
    },
    addRetirement() {
      this.retirements.push({
        owner: null,
        type: null,
        current_value: null,
        monthly_contribution: null,
        employer_matchback_amount: null
      })
    },
    removeRetirement(index) {
      this.retirements.splice(index, 1)
    },
    addInsurance() {
      this.insurances.push({
        owner: null,
        type: null,
        company: null,
        death_benefit: null,
        monthly_premium: null,
        term_left: null,
        cash_value: null
      })
    },
    removeInsurance(index) {
      this.insurances.splice(index, 1)
    },
    addSavings () {
      this.savings.push({
        owner: null,
        type: null,
        current_value: null,
        monthly_contribution: null
      })
    },
    removeSavings (index) {
      this.savings.splice(index, 1)
    },
    addDesiredOutcomes () {
      if(this.desiredOutcomes.length < 5) this.desiredOutcomes.push('')
    },
    removeDesiredOutcome (index) {
      this.desiredOutcomes.splice(index, 1)
    },
    formatDate (date) {
      if (!date) return null

      const [year, month] = date.split('-')
      return `${month}/${year}`
    },
    parseDate (date) {
      console.log('parse', date)
      if (!date) return null

      let [month, year, year2] = date.split('/')
      if(year2) year = year2
      return `${year}-${month.padStart(2, '0')}`
    },
    allowedDates(val) {
      return this.$moment().format('YYYY-MM') < val
    },

    saveSettings() {
      this.saving = true

      this.retirements.forEach((r,i) => {
        if(!r.id) this.retirements[i].id = Date.now() + '-' + Math.floor(Math.random() * 100000000)
      })
      this.insurances.forEach((r,i) => {
        if(!r.id) this.insurances[i].id = Date.now() + '-' + Math.floor(Math.random() * 100000000)
      })
      this.savings.forEach((r,i) => {
        if(!r.id) this.savings[i].id = Date.now() + '-' + Math.floor(Math.random() * 100000000)
      })

      let data = {
        user_id: this.owner.id,
        spouse_id: (this.spouse ? this.spouse.id : null),
        prepared_by: this.newPreparedBy,
        prepared_by_title: this.newPreparedByTitle,
        prepared_by_email: this.newPreparedByEmail,
        intake: {
          desiredOutcomes: this.desiredOutcomes,
          mainIncomes: this.mainIncomes,
          incomes: this.incomes,
          retirements: this.retirements,
          insurances: this.insurances,
          savings: this.savings,
          lifestyleChanges: this.lifestyleChanges,
          lifestyleChangeReason: this.lifestyleChangeReason,
          happyCurrentCashflow: this.happyCurrentCashflow,
          whyNotHappy: this.whyNotHappy,
          anticipateCashflowChanges: this.anticipateCashflowChanges,
          cashflowChanges: this.cashflowChanges,
          anticipateMajorExpenditures: this.anticipateMajorExpenditures,
          majorExpenditure: this.majorExpenditure
        }
      }
      this.$http.put('households/' + this.household.id + '?expand=' + this.expansions, data)
        .then(response => {
          this.$emit('on-intake-updated', response.data)
        })
        .catch(err => {
          console.log(err.response)
          this.$swal.fire('Error', 'There was an error processing your information', 'error')
        })
        .finally(() => {
          this.saving = false
        })
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
